import axios from "axios"

const REACT_APP_HOST = process.env.REACT_APP_HOST

const getOrder = async (id: string | number | undefined, token: string) => {
  const getOrderURL = `${REACT_APP_HOST}/api/orders/${id}`

  const config = {
    headers: { Authorization: token },
  }

  const res = await axios.get(getOrderURL, config)
  return res.data
}

const getOrders = async (token: string, status: string) => {
  const getOrdersURL = `${REACT_APP_HOST}/api/orders/all/${status}`
  const config = {
    headers: { Authorization: token },
  }

  const res = await axios.get(getOrdersURL, config)
  return res.data
}

const updateOrderStatus = async (
  token: string, 
  payload: any, 
  id: string | number
) => {
  const updateOrderURL = `${REACT_APP_HOST}/api/orders/${id}`
  const config = {
    headers: { Authorization: token },
  }

  const res = await axios.put(updateOrderURL, payload, config)
  return res.data
}

export { getOrder, getOrders, updateOrderStatus }